<template>
  <main class="home">
    <header class="header">
      <img
        class="is-hidden-desktop img-banner"
        src="../assets/images/banners/guias_mobile.svg"
        alt=""
      />
      <div
        class="header__content-wrap column is-half-desktop is-offset-half-desktop"
      >
        <div class="header__content">
          <h2 class="color-primary mb-3">
            Sustenta el traslado de productos <br />
            de tu negocio
          </h2>
          <p>
            ContaFácil te permite gestionar el traslado de
            <br class="is-hidden-touch" />
            productos de forma sencilla. Emite guías
            <br class="is-hidden-touch" />cuando lo requieras y monitorea la
            salida
            <br class="is-hidden-touch" />
            de productos.
          </p>
          <div class="header__actions">
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
            <a class="button is-rounded bg-disabled" @click="setVideoDemo"
              >Video Demo</a
            >
          </div>
        </div>
      </div>
    </header>
    <tab-modules></tab-modules>
    <section class="section no-padding--left no-padding--right">
      <div class="columns is-desktop section__video">
        <div class="remision column">
          <img class="mal" src="../assets/images/remision_1.png" alt />
        </div>
        <div class="video__text column is-two-fifths-desktop">
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Guías de remisión en tan solo <br class="is-hidden-touch" />
              unos pasos
            </h3>
            <p>
              Emite guías de remisión<br class="is-hidden-touch" />
              electrónica de forma fácil y rápida.
              <br class="is-hidden-touch" />
              Si tienes comprobantes de<br class="is-hidden-touch" />
              venta relacionados se jalará<br class="is-hidden-touch" />
              automáticamente la<br class="is-hidden-touch" />
              información de productos a<br class="is-hidden-touch" />
              transportar y del comprobante.
            </p>
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary button-ml-0"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div
        class="columns is-desktop section__video section__video--column mar-top"
      >
        <div class="video-mini column">
          <div class="remision">
            <img src="../assets/images/remision_2.png" alt class="img-center" />
          </div>
          <div class="video-mini__text">
            <h3 class="color-primary">
              Ten seguimiento de la salida de productos
            </h3>
            <p>
              Monitorea la salida de productos de tus<br
                class="is-hidden-touch"
              />
              puntos de venta en un solo sitio. Controla la<br
                class="is-hidden-touch"
              />
              emisión y el movimiento de stock de las<br
                class="is-hidden-touch"
              />
              guías de remisión electrónicas y genera<br
                class="is-hidden-touch"
              />
              reportes al instante.
            </p>
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
    </section>
    <one-view></one-view>
  </main>
</template>

<script>
// @ is an alias to /src
import TabModules from "../components/TabModules";
import OneView from "../components/OneView";
import { EventBus } from "@/event-bus";
export default {
  name: "GuiaRemision",
  components: {
    TabModules,
    OneView
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    },
    setVideoDemo() {
      EventBus.$emit("triggerGtag", "video_demo");
      this.$modal.show("video-demo", {
        src: `<iframe width="560" height="315" src="https://www.youtube.com/embed/j5j9OfJimmg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.header {
  // height: calc(100vh - 75px);
  // background-image: url("../assets/images/banners/guias_mobile.svg");
  // background-repeat: no-repeat;
  // background-size: 100% auto;
  // background-attachment: local;
  // background-origin: border-box;
  &__content-wrap {
    justify-content: flex-end;
    padding-bottom: 18%;
  }
  &__content {
    background-color: transparent;
    margin-top: auto;
    // height: 70%;
    width: 100%;
    p {
      width: 100%;
    }
  }
  @include tablet() {
    background-image: none;
    height: fit-content;
    // max-height: 600px;
    // padding: 4em 0;
  }
  @media (min-width: 1024px) {
    height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/remision.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 500px;
    &__content-wrap {
      // justify-content: center;
      padding-bottom: 0%;
    }
    &__content {
      background-color: transparent;
      height: 70%;
      width: 100%;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1200px) {
    height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/remision.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 690px;
  }
  @media (min-width: 1800px) {
    height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/remision.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 1230px;
  }
}
.section {
  // padding: 3rem;
  padding-top: 0px;
  .button {
    font-size: 16px;
    width: fit-content;
    // font-weight: 500;
  }
  h2 {
    font-weight: bold;
    font-size: 3rem;
  }
  &__video {
    width: 100%;
    margin: 1rem 0px;
    // min-height: 560px;
    // display: flex;
    // flex-flow: column nowrap;
    // justify-content: flex-start;
    // align-items: stretch;
    @include laptop() {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: stretch;
      margin: 4em 0px;
    }
    @include desktop() {
      margin: 7em 0px;
    }
    // min-height: 450px;
    // padding: 2rem;
    .video__text {
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
      // order: 2;
      &--right {
        text-align: center;
        align-items: flex-end;
      }
      h3 {
        letter-spacing: 0.075em;
        font-size: 16px;
        width: 100%;
        font-weight: bold;
        margin: 2em auto;
      }
      p {
        width: 90%;
        font-size: 16px;
        letter-spacing: 0.05em;
        font-weight: 400;
        margin: 2em auto;
      }
      .button {
        // max-width: 200px;
        margin: 1rem auto;
      }
      @include tablet() {
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: center;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          width: 90%;
          font-weight: bold;
        }
        p {
          width: 90%;
          font-size: 1.5rem;
        }
        .button {
          // max-width: 200px;
          font-size: 1.2rem;
          margin: 1rem auto;
        }
      }
      @media (min-width: 1024px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        order: 0;
        &--right {
          text-align: right;
          align-items: flex-end;
          order: 1;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.3rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          // width: 90%;
          width: 100%;
          font-size: 1.2rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @media (min-width: 1200px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.4rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          // width: 90%;
          font-size: 1.4rem;
          letter-spacing: 0.075em;
          font-weight: 400;
          margin: 1em 0;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop-medium() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.5rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          // width: 90%;
          font-size: 1.5rem;
          letter-spacing: 0.075em;
          font-weight: 400;
          margin: 1em 0;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @media (min-width: 1800px) {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
    }
    .video__player,
    .video-mini__player {
      order: 1;
      background-image: url("../assets/images/video-placeholder.png");
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      @include laptop() {
        // order: 0;
      }
    }
    .remision {
      padding: 0px;
      order: 1;
      margin: 0;
      .img-center {
        max-width: 900px;
        width: 100%;
        margin: 0 auto;
        // margin-left: 5%;
      }
      img {
        height: auto;
      }
      @include tablet() {
        display: flex;
        align-items: flex-start;
        img {
          width: 100%;
          object-fit: contain;
        }
        .img-center {
          width: 100%;
          max-width: none;
        }
      }
      @include laptop() {
        // order: 0;
        img {
          max-width: none;
          width: 100%;
        }
        .img-center {
          margin-top: 8em;
          max-width: none;
          width: 90%;
        }
      }
      @include desktop-large() {
        .img-center {
          max-width: none;
          width: 90%;
        }
      }
    }
    .video-mini {
      margin-top: 2rem;
    }
    .video-mini__player {
      height: 300px;
    }
    .video-mini__text {
      margin: 0 auto;
      margin-top: 3rem;
      width: 100%;
      h3 {
        letter-spacing: 0.05em;
        font-size: 16px;
        font-weight: bold;
        margin: 2em auto;
      }
      p {
        font-size: 16px;
        letter-spacing: 0.025em;
        margin: 2em auto;
      }
      .button {
        margin: 1rem auto;
      }
      @include tablet() {
        margin: 0 auto;
        margin-top: 3rem;
        width: 100%;
        h3 {
          letter-spacing: 0.018em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
        }
        .button {
          // width: 200px;
          font-size: 1.2rem;
          margin: 1rem auto;
        }
      }
      @include laptop() {
        margin: 0 auto;
        margin-top: 3rem;
        width: 100%;
        h3 {
          letter-spacing: 0.018em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.3rem;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          margin: 1rem auto;
        }
      }
      @include desktop() {
        margin: 0 auto;
        margin-top: 3rem;
        width: 100%;
        h3 {
          letter-spacing: 0.018em;
          font-size: 1.4rem;
          font-weight: bold;
        }
        p {
          font-size: 1.4rem;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          margin: 1rem auto;
        }
      }
      @include desktop() {
        margin: 0 auto;
        margin-top: 3rem;
        width: 100%;
        h3 {
          letter-spacing: 0.018em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          margin: 1rem auto;
        }
      }
      @include desktop-large() {
        margin: 0 auto;
        margin-top: 3rem;
        width: 100%;
        h3 {
          letter-spacing: 0.018em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          margin: 1rem auto;
          font-size: 1.2rem;
        }
      }
    }
    &:first-child {
      padding-top: 0px;
    }
    &--column {
      width: 100%;
      margin: 0 auto;
      flex-flow: column nowrap !important;
      justify-content: flex-start;
      align-items: center;
      h3 {
        letter-spacing: 0.05em;
        font-size: 16px;
        font-weight: bold;
      }
      p {
        font-size: 16px;
        letter-spacing: 0.025em;
      }
      .video__player {
        width: 100%;
        height: 500px;
      }
      @include tablet() {
        width: 75%;
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
          letter-spacing: 0.025em;
        }
      }
      @include laptop() {
        width: 90%;
        h3 {
          letter-spacing: 0.05em;
          font-size: 16px;
          font-weight: bold;
        }
        p {
          font-size: 16px;
          letter-spacing: 0.025em;
        }
      }
    }
    @include laptop() {
      margin: 4rem auto;
    }
  }
}
.factura-img {
  display: block;
  width: 500px;
  margin: 4rem auto;
}
</style>
